import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKaiChatLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 28,
	viewBox: "0 0 30 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1.25,
			y: 1.25,
			width: 16.5,
			height: 25.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.25,
			y: 1.25,
			width: 16.5,
			height: 25.5,
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.7021 1.25L27 2.39258L19.791 14.1113L26.9961 25.6016L27.7158 26.75H11.0039L10.7832 26.3984L3.33105 14.5137L3.08398 14.1191L3.32812 13.7217L10.7803 1.60742L11 1.25H27.7021Z",
			fill: "white",
			stroke: "black",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.41406 14H19.8383",
			stroke: "black",
			strokeWidth: 1.5
		})
	]
});
export default SvgKaiChatLogo;
